import { translateToChineseApi } from '@/api/translate';

async function translateToChinese(englishName) {
  // let chinese;
  return await translateToChineseApi({ text: englishName });
}

export { translateToChinese };
